const COOKIE_CONSENT_KEY = "cookie-consent";

export interface CookieConsent {
  necessary: boolean; // zawsze true
  analytics: boolean; // GA, FB Pixel
  advertising: boolean; // Google AdSense
}

const DEFAULT_CONSENT: CookieConsent = {
  necessary: true,
  analytics: false,
  advertising: false,
};

export function getCookieConsent(): CookieConsent {
  try {
    const stored = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!stored) return DEFAULT_CONSENT;
    return JSON.parse(stored);
  } catch {
    return DEFAULT_CONSENT;
  }
}

export function setCookieConsent(consent: CookieConsent): void {
  localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(consent));
  window.dispatchEvent(new CustomEvent("cookie-consent-changed"));
}

export function hasUserRespondedToConsent(): boolean {
  return localStorage.getItem(COOKIE_CONSENT_KEY) !== null;
}

export function acceptAllCookies(): void {
  setCookieConsent({ necessary: true, analytics: true, advertising: true });
}

export function acceptNecessaryOnly(): void {
  setCookieConsent({ necessary: true, analytics: false, advertising: false });
}
